export interface FilterLeaf {
  key: string;
  value: any;
  operation: string;
}

export interface FilterGroup {
  combinator: "AND" | "OR";
  filters: FilterItem[];
}

export type FilterItem = FilterLeaf | FilterGroup;

export interface SubviewConfig {
  id: string;
  label: string;
  display_order: number;
  filters: FilterItem[];
  columns?: string[];
}

// TODO: Replace this with the actual subview config from the configuration service
export const QUEUE_SUBVIEW_CONFIG: { subviewConfig: SubviewConfig[] } = {
  subviewConfig: [
    {
      id: "ready-for-distribution",
      label: "Ready for Distribution",
      display_order: 0,
      filters: [
        {
          combinator: "OR",
          filters: [
            {
              key: "workitem.hold_status",
              value: "OFF_HOLD",
              operation: "eq",
            },
            {
              key: "workitem.hold_status",
              value: null,
              operation: "is",
            },
          ],
        },
        { key: "workitem.owner", value: null, operation: "is" },
        {
          key: "workitem.case_status",
          value: ["SUBMITTED", "VOID", "CANCELLED", "SENT"],
          operation: "not in",
        },
        { key: "workitem.is_chargeable", value: true, operation: "eq" },
      ],
    },
    {
      id: "assigned",
      label: "Assigned",
      display_order: 1,
      filters: [
        {
          combinator: "OR",
          filters: [
            {
              key: "workitem.hold_status",
              value: "OFF_HOLD",
              operation: "eq",
            },
            {
              key: "workitem.hold_status",
              value: null,
              operation: "is",
            },
          ],
        },
        { key: "workitem.owner", value: null, operation: "is not" },
        {
          key: "workitem.case_status",
          value: ["SUBMITTED", "VOID", "CANCELLED", "SENT"],
          operation: "not in",
        },
        { key: "workitem.is_chargeable", value: true, operation: "eq" },
      ],
    },
    {
      id: "holds&requests",
      label: "Holds & Requests",
      display_order: 2,
      filters: [
        {
          key: "workitem.hold_status",
          value: "OFF_HOLD",
          operation: "ne",
        },
        {
          key: "workitem.hold_status",
          value: null,
          operation: "is not",
        },
        {
          key: "workitem.case_status",
          value: ["SUBMITTED", "VOID", "CANCELLED", "SENT"],
          operation: "not in",
        },
        { key: "workitem.is_chargeable", value: true, operation: "eq" },
      ],
    },
    {
      id: "submitted",
      label: "Submitted",
      display_order: 3,
      filters: [
        {
          key: "workitem.case_status",
          value: ["SUBMITTED", "VOID", "CANCELLED", "SENT"],
          operation: "in",
        },
        { key: "workitem.is_chargeable", value: true, operation: "eq" },
      ],
    },
    {
      id: "excluded",
      label: "Excluded",
      display_order: 4,
      filters: [
        { key: "workitem.is_chargeable", value: false, operation: "eq" },
      ],
    },
  ],
};

export const DEFAULT_SUBVIEW_ID = QUEUE_SUBVIEW_CONFIG.subviewConfig[0].id;

export const getSubviewById = (id: string | null): SubviewConfig | undefined =>
  QUEUE_SUBVIEW_CONFIG.subviewConfig.find((sv) => sv.id === id);

export const getSubviewFilters = (activeSubviewId: string | null) => {
  if (!activeSubviewId) return [];
  return getSubviewById(activeSubviewId)?.filters || [];
};

export const isQueueView = (view: any): boolean => view?.scope === "QUEUE_VIEW";
